'use strict';
import angular from 'angular';


export class FooterComponent {
    /*@ngInject*/
    constructor($http, $scope, searchService) {
        this.$http = $http;
        this.$scope = $scope;
        this.feedback = {};
        this.failed = false;
        this.success = false;
        this.savingSpinner = false;
        this.searchService = searchService;
    }

    $onInit(){
        this.$scope.baseURL = this.searchService.getBaseURL();
        this.getCopyright('Standards of Care');
    }

    showModal(index) {
        this.activeTab = index;
        $('#myModal').modal();
    }

    getCopyright(type) {
        //Get Copyright
        var key;
        this.$http.get(`${this.$scope.baseURL}/api/data/copyright/${type}`)
        .then(response => {
            this.$scope.copyrightCW = response.data[0].copyright;
        })
        .catch(err => {
            console.log(err);
        })
    }

    submitFeedback($form) {
        console.log($form.$valid);
        this.savingSpinner = true;
        console.log(this.feedback);
        if ($form.$valid) {

            this.$http.post('/api/users/feedback', this.feedback)
                .then(response => {
                    this.savingSpinner = false;
                    console.log(response);
                    this.feedback = {};
                    this.success = true;
                    this.failed = false;
                    console.log(this.savingSpinner);

                })
                .catch(err => {
                    this.savingSpinner = false;
                    console.log(err);
                    this.success = false;
                    this.failed = true;


                })
        } else {
            this.failed = true;
            this.success = false;
        }

    }

}

export default angular.module('directives.footer', [])
    .component('footer', {
        template: require('./footer.html'),
        controller: FooterComponent
    })
    .name;


// WEBPACK FOOTER //
// ./client/components/footer/footer.component.js